transferToFixedLength